import dayjs from 'dayjs';
import React, { useState } from 'react';
import DownloadCSV from '~components/molecules/DownloadCSV';
import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import { FundTypeEnum } from '~utils/enums';
import UtilFunctions from '~utils/functions';

const InventoryReceivedExportCSV = () => {
    const dispatch = useAppDispatch();
    const { Misc: { dateTimeFormat } } = UtilFunctions;

    const inventoryReceivedListing = useAppSelector(state => state.gold.inventoryReceivedListingForExport);
    const exportInventoryReceivedIsLoading = useAppSelector(state => state.gold.loadings.exportInventoryReceivedListing);

    const exportInventoryReceived = () => dispatch(combinedActions.goldExportInventoryReceivedListingAttempt());
    const clearInventoryReceivedListingForExport = () => dispatch(combinedActions.goldClearInventoryReceivedListingForExport());

    const [isExportingInventoryReceivedListing, setIsExportingInventoryReceivedListing] = useState<boolean>(false);

    const handleExportInventoryReceivedListingCleanup = () => {
        clearInventoryReceivedListingForExport();
        setIsExportingInventoryReceivedListing(false);
    };

    const listHeader = [
        'PRODUCT NAME',
        'RECEIVED FROM',
        'SERIAL NUMBER',
        'QUANTITY',
        'TOTAL GOLD WEIGHT (g)',
        'FUND TYPE',
        'RECEIVED AT',
    ];

    const listData = inventoryReceivedListing.map(inventory => {
        const {
            product,
            from,
            serialNumbers,
            quantity,
            fundType,
            totalGoldWeight,
            createdAt,
        } = inventory;

        const massagedSerialNumbers = serialNumbers.map(serial => serial.serialNo).filter(item => item);

        return [
            product.productName,
            from.branchName,
            massagedSerialNumbers.join(', '),
            quantity,
            totalGoldWeight,
            FundTypeEnum[fundType],
            dateTimeFormat(createdAt),
        ];
    });

    return (
        <DownloadCSV
            buttonLabel='Export to CSV'
            header={listHeader}
            data={listData}
            fileName={dayjs().format('DD-MM-YYYY').concat(' Inventory Received')}
            onClick={exportInventoryReceived}
            cleanup={handleExportInventoryReceivedListingCleanup}
            isLoading={exportInventoryReceivedIsLoading || isExportingInventoryReceivedListing}
        />
    );
};

export default InventoryReceivedExportCSV;
